import { MapProvider } from "@vis.gl/react-maplibre";
import { useState } from "react";
import { useLocation } from "wouter";
import { BaseMap } from "../components/map/BaseMap";
import { HourScrubber } from "../components/map/HourScrubber";
import { SpotCircles } from "../components/map/SpotCircles";
import { WindParticles } from "../components/map/WindParticles";
import { useForecast } from "../lib/api";
import { currentHourIndex, useWindGrid } from "../lib/windGrid";
import styles from "./MapPrototypePage.module.css";

export function MapPrototypePage() {
  const [, setLocation] = useLocation();
  const [hourIndex, setHourIndex] = useState(currentHourIndex);
  const { data: forecast } = useForecast();
  const { data: windSlices, isLoading: windLoading } = useWindGrid();

  const spots = forecast?.spots ?? [];
  const currentSlice = windSlices?.[hourIndex] ?? null;

  return (
    <div className={styles.page}>
      <MapProvider>
        <div className={styles.mapContainer}>
          <BaseMap>
            <WindParticles slice={currentSlice} />
            {spots.length > 0 && (
              <SpotCircles
                spots={spots}
                onSpotClick={(id) => setLocation(`/spot/${id}`)}
              />
            )}
          </BaseMap>
        </div>
      </MapProvider>

      {/* Floating HUD */}
      <div className={styles.hud}>
        <div className={styles.title}>Map Prototype</div>

        <HourScrubber
          hourIndex={hourIndex}
          onChange={setHourIndex}
        />

        {windLoading && (
          <div className={styles.status}>Loading wind data…</div>
        )}
        {!windLoading && !windSlices && (
          <div className={styles.statusError}>
            Wind data unavailable — check API connection.
          </div>
        )}
      </div>

      {/* Back link */}
      <button
        type="button"
        className={styles.backButton}
        onClick={() => setLocation("/dev")}
      >
        ← Dev
      </button>
    </div>
  );
}
